define( '../src/sublayouts/m18-modal/m18-modal',[ 'jquery', 'lib/utils', 'mask', 'spinner' ], function ( $, utils, Mask, Spinner ) {
    'use strict';

    var M18_MODAL = function ( $component ) {

        this.$component = $component;

        return this;
    };

    M18_MODAL.prototype.init = function () {

        // set a unique id (safer than doing this inline)
        var uniqueID = utils.uniqueID(),
            triggerID = uniqueID + '_trigger',
            contentID = uniqueID + '_content',
            closeID = uniqueID + '_close';

        // cache dom els
        this.$content = this.$component.find( '[ data-content ]' );
        this.$close = this.$component.find( '[ data-close ]' );
        this.$body = $( 'body' );
        this.$modalContent = this.$component.find( '.m18-modal__content' );

        if ( this.$content.data( 'content' ) === true ) {

            this.$trigger = this.$component.find( '[ data-trigger ]' );

        } else {
            if ( this.$trigger[ 0 ] === undefined ) {
                this.$trigger = $( '[ data-modal-trigger="' + this.$content.data( 'content' ) + '" ]' );
            }
        }

        
        if( this.$content.data( 'fetch' )){
            this.$fetchData = this.$content.attr('data-fetch');
            this.$fetchContent = $("#"+this.$fetchData).html();
            this.$content.find('.m18-modal__content').html(this.$fetchContent)
        }


        // make sure trigger is not triggred when hitting enter in a form
        if ( this.$trigger.is( 'button' ) ) {

            this.$trigger.attr( 'type', 'button' );
        }

        // add dynamic ids and props for aria tagging
        this.$trigger.attr( 'id', triggerID ).attr( 'aria-controls', contentID );
        this.$content.attr( 'id', uniqueID + '_content' ).attr( 'aria-labelledby', triggerID );
        this.$close.attr( 'id', closeID ).attr( 'aria-controls', contentID );

        // classnames
        this.openContentClassname = 'm18-modal__container--active';

        // bind events
        this.$trigger.on( 'click', $.proxy( this.show, this ) );
        this.$close.on( 'click', $.proxy( this.hide, this ) );

        if(!this.$component.hasClass('capchamo')){
            this.$body.on( 'focusin', $.proxy( this.checkModalFocus, this ) );
        }

    };

    M18_MODAL.prototype.checkModalFocus = function ( e ) {

        var _this = this;

        window.setTimeout( function () {

            if ( _this.modalOpened && _this.$content.find( ':focus' ).length === 0 ) {

                e.stopPropagation();
                _this.$close.click();
            }

        }, 1 );

    };

    M18_MODAL.prototype.show = function ( e ) {

        var _this = this;

        var spinner = new Spinner( _this.$content  );
        spinner.load();

        e.preventDefault();

        setTimeout(function(){

            Mask.show();
            _this.$body.addClass( 'unscrollable' );

            _this.setContentBelowHeader();
            $( window ).on( 'resize orientationchange', $.proxy( _this.setContentBelowHeader, _this ) );

            _this.$content.attr( 'aria-expanded', true );
            _this.$content.addClass( _this.openContentClassname );

            window.setTimeout( function () {
                
                spinner.unload();
                _this.$close.focus();
                $('body').trigger('modal_opened', _this);

                $(window).on('keyup', function(e) {
                    if (e.key == "Escape"){
                        _this.$close.trigger('click')
                    }
                  });
                
                 
            }, 501 ); // let the css visibility transition finish... otherwise .focus() will fail. ugly but necessary.

            _this.modalOpened = true;

            
        }, 50);
    };

    M18_MODAL.prototype.setContentBelowHeader = function () {

        this.headerHeight = this.$component.find( '.m18-modal__header' ).innerHeight() + 'px';
        this.$modalContent.css( 'top', this.headerHeight );
    };

    M18_MODAL.prototype.hide = function ( e ) {

        e.preventDefault();

        $('body').trigger('modal_closed', this);

        Mask.hide();

        this.$body.removeClass( 'unscrollable' );
        this.$content.attr( 'aria-expanded', false );
        this.$content.removeClass( this.openContentClassname );
        this.modalOpened = false;
        if(!this.$trigger.hasClass('ad-modal')){
            this.$trigger.focus();
        }
    };

    return M18_MODAL;

} );

